import {COUNTRY_CURRICULA} from '#/screens/Onboarding/StepGoal/data'

/**
 * A country, as a person reads it.
 *
 * A classroom carries its country as the code onboarding recorded (`TN`), and a
 * door owes the person a name rather than a code: *this classroom is for
 * learners in Tunisia*, not *…in TN*. The names live with the curricula
 * (`COUNTRY_CURRICULA`), which is the list onboarding already picks from — one
 * list, so a country the app knows how to ask about is a country it can name.
 *
 * A code the list does not carry is printed as it is: a name the app cannot
 * spell is not a reason to say nothing about which country took the door.
 */
export function countryName(code: string | null | undefined): string {
  const trimmed = (code ?? '').trim().toUpperCase()
  if (!trimmed) return ''
  return COUNTRY_CURRICULA[trimmed]?.name ?? trimmed
}

/** The country's flag, when the list carries one — `countryName`'s companion. */
export function countryFlag(code: string | null | undefined): string {
  const trimmed = (code ?? '').trim().toUpperCase()
  if (!trimmed) return ''
  return COUNTRY_CURRICULA[trimmed]?.flag ?? ''
}
